"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagsFormat = TagsFormat;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Chip = _interopRequireDefault(require("@eig-builder/core-ui/Chip"));

var _alphanumSort = _interopRequireDefault(require("alphanum-sort"));

var generateOrderByChipsFromGlobalVariants = function generateOrderByChipsFromGlobalVariants(record) {
  return (0, _orderBy["default"])(record.globalVariantOptions, 'order').map(function (item) {
    var colorIcon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "stop",
      style: {
        color: item.displayName,
        marginRight: '-20px'
      }
    });

    return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
      className: "m-1",
      label: record.variantType === 1 ? '' : item.displayName // only show label when it's not color type
      ,
      icon: record.variantType === 1 ? colorIcon : undefined,
      key: item.displayName
    });
  });
};

var generateNaturalSortChipsFromGlobalVariants = function generateNaturalSortChipsFromGlobalVariants(record) {
  return (0, _alphanumSort["default"])(record.globalVariantOptions.map(function (i) {
    return i.displayName;
  })).map(function (item) {
    var colorIcon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "stop",
      style: {
        color: item,
        marginRight: '-20px'
      }
    });

    return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
      className: "m-1",
      label: record.variantType === 1 ? '' : item // only show label when it's not color type
      ,
      icon: record.variantType === 1 ? colorIcon : undefined,
      key: item
    });
  });
};

var generateChipsFromVariants = function generateChipsFromVariants(record) {
  return record.product_variant_options.map(function (item) {
    var colorIcon = /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "stop",
      style: {
        color: item.display_name
      }
    });

    return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
      className: "m-1",
      label: record.variant_type === 1 ? '' : item.display_name // only show label when it's not color type
      ,
      icon: record.variant_type === 1 ? colorIcon : undefined,
      key: item.id
    });
  });
};

function TagsFormat(params) {
  var record = params.data;

  if ((0, _isNil["default"])(record.product_variant_options)) {
    if (record.globalVariantOptions && record.globalVariantOptions.length > 0 && record.globalVariantOptions[0].order !== null) {
      return generateOrderByChipsFromGlobalVariants(record);
    } else {
      return generateNaturalSortChipsFromGlobalVariants(record);
    }
  } else {
    return generateChipsFromVariants(record);
  }
}